import React, { useEffect, useState } from "react";
import { req } from "./api";
import { Field, Msg } from "./fields";

const STATUSES = ["new", "assigned", "replied", "closed"];
const TYPES = ["Capital raising", "M&A or joint venture", "Valuation or due diligence", "Project finance", "Sustainable or Islamic finance", "Restructuring", "Market entry", "Strategy and performance", "Family office", "Reporting, tax or CFO support", "Rivera Enterprises", "Company profile request", "Media or speaking", "Prepare my profile and DPR", "Other"];
const MARKETS = { bd: "Bangladesh", in: "India", sg: "Singapore" };

export default function Inbox() {
  const [items, setItems] = useState(null);
  const [open, setOpen] = useState(null);
  const [msg, setMsg] = useState("");

  const fetchList = async () => {
    try {
      const r = await req("/admin/enquiries");
      setItems(r.sort((a, b) => String(b.createdAt).localeCompare(String(a.createdAt))));
    } catch (e) {
      setMsg(e.message);
      setItems([]);
    }
  };
  useEffect(() => { fetchList(); }, []);

  const update = async (id, patch) => {
    try {
      await req(`/admin/enquiries/${id}`, { method: "PUT", body: patch });
      fetchList();
    } catch (x) { setMsg(x.message); }
  };

  if (!items) return <p className="muted">Loading…</p>;
  return (
    <div>
      <Msg msg={msg} />
      <div className="row-actions" style={{ marginBottom: 18 }}>
        <a className="btn sm ghost" href="/api/admin/enquiries.csv" data-testid="enquiries-csv">Export CSV</a>
      </div>
      {items.length ? (
        <div className="tbl-wrap"><table className="tbl" data-testid="enquiries-table">
          <thead><tr><th>Received</th><th>From</th><th>About</th><th>Status</th><th></th></tr></thead>
          <tbody>{items.map((e) => (
            <React.Fragment key={e.id}>
              <tr>
                <td className="num">{new Date(e.createdAt).toLocaleString("en-GB", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</td>
                <td><strong>{e.name}</strong><div className="muted small">{e.org}</div><div className="muted small">{e.email}{e.phone ? " · " + e.phone : ""}</div></td>
                <td>{TYPES[e.type] || "Other"}{e.market ? <> · <span className="pill" data-testid={`enquiry-market-${e.id}`}>{MARKETS[e.market] || e.market}</span></> : null}<div className="muted small">{e.message?.slice(0, 90)}{e.message?.length > 90 ? "…" : ""}</div></td>
                <td><span className={`pill${e.status === "new" ? " on" : ""}`}>{e.status}</span></td>
                <td><button className="btn sm ghost" onClick={() => setOpen(open === e.id ? null : e.id)} data-testid={`enquiry-open-${e.id}`}>{open === e.id ? "Close" : "Open"}</button></td>
              </tr>
              {open === e.id && (
                <tr><td colSpan={5} style={{ background: "var(--tint)" }}>
                  <div className="stack" style={{ gap: 14 }}>
                    <p style={{ whiteSpace: "pre-wrap" }}>{e.message}</p>
                    <div className="row-actions">
                      <Field label="Status"><select value={e.status} onChange={(ev) => update(e.id, { status: ev.target.value })} data-testid={`enquiry-status-${e.id}`}>{STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}</select></Field>
                      <Field label="Assignee"><input defaultValue={e.assignee || ""} onBlur={(ev) => update(e.id, { assignee: ev.target.value })} placeholder="Who is replying" /></Field>
                      <a className="btn sm" href={`mailto:${e.email}?subject=Re: Your enquiry to Rivera Holdings`} data-testid={`enquiry-reply-${e.id}`}>Reply by email</a>
                    </div>
                    <Field label="Internal notes" full><textarea rows={2} defaultValue={e.notes || ""} onBlur={(ev) => update(e.id, { notes: ev.target.value })} /></Field>
                  </div>
                </td></tr>)}
            </React.Fragment>))}</tbody></table></div>
      ) : <div className="empty">No enquiries yet. New enquiries also arrive by email.</div>}
    </div>
  );
}
